import React from "react";
import {
  Dialog,
  DialogContent,
  Button,
  Typography,
  Box,
  Link,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import { GoogleLogin } from "@react-oauth/google";
import { useTranslation } from "react-i18next";

const SignInPrompt = (props) => {
  const { state, mainFunctions, basicFunctions } = props;
  const { t } = useTranslation();
  const pathname = window.location.pathname;

  // Only show sign-in prompt on TierList and Grid pages
  const showOnPages = ["/TierList", "/tier-list", "/Grid"];
  const shouldShow = showOnPages.some((p) => pathname.startsWith(p));

  const autoShow = !state.user && !state.isGuest && !state.isAuthenticated && shouldShow;
  const explicitShow = !state.user && !state.isAuthenticated && state.showSignInPrompt;

  return (
    <Dialog
      id="sign-in-prompt"
      open={autoShow || explicitShow}
      onClose={() => {
        if (explicitShow) {
          basicFunctions.updateState({ showSignInPrompt: false });
        }
      }}
      PaperProps={{
        sx: {
          borderRadius: 3,
          backgroundImage: "none",
          maxWidth: 400,
          mx: 2,
        },
      }}
    >
      <DialogContent sx={{ px: 4, py: 4, textAlign: "center" }}>
        <Typography variant="h5" sx={{ fontWeight: 700, mb: 1 }}>
          {t("auth.signInTitle")}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3, lineHeight: 1.6 }}>
          {t("auth.signInDescription")}
        </Typography>

        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
          <GoogleLogin
            onSuccess={(credentialResponse) => {
              if (credentialResponse.credential) {
                basicFunctions.updateState({ showSignInPrompt: false });
                mainFunctions.handleGoogleSignIn(credentialResponse.credential);
              }
            }}
            onError={() => {
              console.error("Google Sign-In failed");
            }}
          />
          <Button
            variant="outlined"
            onClick={() => {
              basicFunctions.updateState({ showSignInPrompt: false });
              mainFunctions.continueAsGuest();
            }}
            sx={{
              textTransform: "none",
              color: "text.secondary",
              borderColor: (theme) => alpha(theme.palette.text.secondary, 0.3),
              "&:hover": {
                borderColor: "text.primary",
                color: "text.primary",
              },
              px: 3,
            }}
          >
            {t("auth.continueAsGuest")}
          </Button>
        </Box>

        <Typography variant="caption" color="text.secondary" sx={{ display: "block", mt: 3, lineHeight: 1.5 }}>
          {t("auth.agreementPrefix")}{" "}
          <Link href="/PrivacyPolicy" sx={{ color: "var(--accent)" }}>
            {t("auth.privacyPolicy")}
          </Link>
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default SignInPrompt;
